import { UrqlOptionOverrides } from "shared/urql";
import { protectionPlanOptimisticResolver } from "./steps/cart/resolvers";

export const rentalUrqlOptions: UrqlOptionOverrides = {
  cacheKeys: {
    // RENTAL APPLICATION
    // Application: data => (data?.portal as any)?.slug || null,
    ApplicationImportantInfo: () => null,
    ApplicationPricing: () => null,
    BankStatements: () => null,
    Customer: () => null,
    Rate: () => null,
    PurchasePrice: () => null,
    RateOption: () => null,
    ApplicationValidation: () => null,
    ApplicationAddress: () => null,
    ApplicationLivingSituation: () => null,
    ProductTypeInfo: () => null,
    Address: () => null,
    Income: () => null,
    TestMode: () => null,
    CreditCard: () => null,
    Portal: data => data.slug as string | null,
    PortalPolicies: () => null,
    PortalAnalytics: () => null,
  },
  optimistic: {
    updateProtectionPlan: protectionPlanOptimisticResolver,
  }
};